export function isBlackFriday() {
  const config = useConfig()
  const blackFridayInitialDate = config.env == "development" ? new Date("2024-11-01T00:00:00-03:00") : new Date("2024-11-11T00:00:00-03:00")
  const blackFridayEndDate = new Date("2024-12-01T00:00:00-03:00")
  const now = new Date()

  return now >= blackFridayInitialDate && now < blackFridayEndDate
}
